export default {"src":"/_next/static/media/prompt.87c0d839.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};